import React from "react";
import FormRadioField from "../../fields/radioField";
import DynamicFieldLabel from "./DynamicFieldLabel";
import SchemaService from "../SchemaService";
import { FormFieldOption } from "../../fields/types";
import { useStaticData } from "../../../../context/staticData";
import DynamicRadioFieldConfigType from "../types/DynamicRadioFieldConfigType";
import FieldAlias from "../enums/FieldAlias";
import { RadioOptionsDisplayStyle } from "shared/form/enum";
import FieldOptionViewType from "../enums/FieldOptionViewType";

/**
 * @name RadioFieldGroupWrapper
 * @param props
 * @constructor
 */

export default function RadioFieldGroupWrapper(props: DynamicRadioFieldConfigType) {
  const staticData = useStaticData();

  const options: Array<FormFieldOption> = React.useMemo(
    () => SchemaService.parseOptions({ schemaObj: props.schemaObj, staticData: staticData }),
    [props.schemaObj, staticData]
  );

  return (
    <React.Fragment>
      <FormRadioField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        disabled={props.schemaObj.disabled}
        options={options}
        required={props.schemaObj.mandatory}
        validate={props.validationFn}
        displayStyle={
          props.schemaObj.alias === FieldAlias.SOCIAL_BUYER ||
          props.schemaObj.fieldOptionViewType === FieldOptionViewType.SINGLE_COLUMN
            ? RadioOptionsDisplayStyle.VERTICAL
            : props.displayStyle
        }
        conflictValue={props.schemaObj.conflictValue}
        fullWidth={true}
        indented={props.schemaObj.indented}
      />
    </React.Fragment>
  );
}
